// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"Modal-module__modalWrapper___31gQu","confirmationBox":"Modal-module__confirmationBox___h4W2Y","closeModal":"Modal-module__closeModal___nTENZ"};